var map = {
	"./bfs/app/shared/lang-switch/lang-switch.component": [
		20711
	],
	"./custom/app/shared/lang-switch/lang-switch.component": [
		1237,
		"src_themes_custom_app_shared_lang-switch_lang-switch_component_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 97394;
module.exports = webpackAsyncContext;